import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";

const HERO_IMG = "/hero-maxence.jpg";

export const Hero = () => {
  const { t } = useTranslation();
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-center pt-28 pb-12 md:pt-28 md:pb-16 overflow-hidden"
    >
      {/* Subtle grid backdrop */}
      <div className="absolute inset-0 adonis-grid-bg [mask-image:radial-gradient(ellipse_at_center,black_30%,transparent_70%)]" />
      {/* Gradient blob */}
      <div
        className="absolute -top-40 -right-40 h-[520px] w-[520px] rounded-full opacity-30 blur-3xl"
        style={{
          background:
            "radial-gradient(circle at 30% 30%, #4DD0E1 0%, transparent 60%), radial-gradient(circle at 70% 70%, #7B61FF 0%, transparent 60%)",
        }}
      />

      <div className="relative w-full max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7 adonis-reveal">
          <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight leading-[1] text-slate-900">
            {t("hero.title_line1")}
            <br />
            <span className="text-slate-400 font-light italic">
              {t("hero.title_line2")}
            </span>
            <br />
            <span className="adonis-gradient-text">{t("hero.title_line3")}</span>
          </h1>

          <p className="mt-8 max-w-xl text-lg leading-relaxed text-slate-600">
            {t("hero.subtitle")}
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Link
              to="/contact"
              data-testid="hero-cta-primary"
              className="group inline-flex items-center gap-2 rounded-full bg-slate-900 px-7 py-4 text-sm font-medium text-white transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-slate-900/20"
            >
              {t("hero.cta_primary")}
              <ArrowRight
                size={16}
                weight="bold"
                className="transition-transform group-hover:translate-x-1"
              />
            </Link>
            <Link
              to="/program"
              data-testid="hero-cta-secondary"
              className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-7 py-4 text-sm font-medium text-slate-900 transition-colors hover:bg-slate-50"
            >
              {t("hero.cta_secondary")}
            </Link>
          </div>
        </div>

        <div className="lg:col-span-5 relative adonis-reveal" style={{ animationDelay: "0.2s" }}>
          <div className="relative">
            {/* Decorative gradient ring */}
            <div className="absolute -inset-3 rounded-[2rem] adonis-gradient opacity-25 blur-2xl" />
            <div className="relative rounded-[2rem] overflow-hidden border border-slate-200 bg-white adonis-gradient-glow">
              <img
                src={HERO_IMG}
                alt="Maxence Hots, fondateur d'Adonis Agency"
                className="w-full h-[440px] lg:h-[520px] object-cover"
                loading="eager"
              />
              {/* Card badge */}
              <div className="absolute bottom-5 left-5 right-5 rounded-2xl bg-white/95 backdrop-blur-xl border border-slate-200 p-4 flex items-center justify-between">
                <div>
                  <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">
                    Founder
                  </p>
                  <p className="font-heading font-bold text-slate-900">
                    Maxence Hots
                  </p>
                  <p className="text-xs text-slate-500">
                    Mathieu Dietsch · Coach &amp; Operator
                  </p>
                </div>
                <div className="h-12 w-12 rounded-full bg-white border border-slate-200 flex items-center justify-center shadow-sm">
                  <img
                    src="/logomark.png"
                    alt="Adonis Agency"
                    className="h-7 w-7 object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
